/* eslint-disable react/prop-types */
import * as Dialog from '@radix-ui/react-dialog';

interface ConfirmDialogProps {
	open: boolean;
	title: string;
	description: string;
	onConfirm: () => void;
	onCancel: () => void;
	confirmColor?: 'red' | 'green'; // nouvelle prop
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
	open,
	title,
	description,
	onConfirm,
	onCancel,
	confirmColor = 'red', // rouge par défaut
}) => {
	const bgColor =
		confirmColor === 'green'
			? 'bg-green-600 hover:bg-green-700'
			: 'bg-red-600 hover:bg-red-700';

	return (
		<Dialog.Root open={open} onOpenChange={(val) => !val && onCancel()}>
			<Dialog.Overlay className="fixed inset-0 bg-black/50 z-40" />
			<Dialog.Content className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded shadow-lg w-[400px] z-50">
				<Dialog.Title className="text-lg font-bold mb-4">{title}</Dialog.Title>
				<Dialog.Description className="mb-6">{description}</Dialog.Description>
				<div className="flex justify-end gap-3">
					<Dialog.Close asChild>
						<button
							className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
							onClick={onCancel}
						>
							Annuler
						</button>
					</Dialog.Close>
					<button
						className={`px-4 py-2 text-white rounded ${bgColor}`}
						onClick={() => {
							onConfirm();
							onCancel();
						}}
					>
						Confirmer
					</button>
				</div>
			</Dialog.Content>
		</Dialog.Root>
	);
};

export default ConfirmDialog;
